// slices/hospitalLocationApiSlice.js

import { apiSlice } from './apiSlice';
import { HOSPITAL_LOCATION_URL } from '../constants';

export const hospitalLocationApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getHospitalLocations: builder.query({
      query: () => ({
        url: `${HOSPITAL_LOCATION_URL}`,
      }),
      keepUnusedDataFor: 5,
    }),

    getHospitalLocationById: builder.query({
      query: (id) => ({
        url: `${HOSPITAL_LOCATION_URL}/${id}`,
      }),
      keepUnusedDataFor: 5,
    }),

    createHospitalLocation: builder.mutation({
      query: (data) => ({
        url: `${HOSPITAL_LOCATION_URL}`,
        method: 'POST',
        body: data,
      }),
    }),

    updateHospitalLocation: builder.mutation({
      query: ({ id, data }) => ({
        url: `${HOSPITAL_LOCATION_URL}/${id}`,
        method: 'PUT',
        body: data,
      }),
    }),
  }),
});

export const {
  useGetHospitalLocationsQuery,
  useGetHospitalLocationByIdQuery,
  useCreateHospitalLocationMutation,
  useUpdateHospitalLocationMutation,
} = hospitalLocationApiSlice;